<script>
import { language } from './stores.js';
import { isMobile } from './stores.js';
let isItInMobile;
isMobile.subscribe(value => {
		isItInMobile = value;
	});
</script>
<div id="home-body">


<img class:mobiimg="{isItInMobile === true}" src="https://payload.cargocollective.com/1/3/120972/14346409/StigFyring_1600_c.jpg" alt="---img---" style="display: inline-block; border-top:0;">

<div id="text"

class:mobitext="{isItInMobile === true}"
class:nonmobitext="{isItInMobile === false}"
>

{#if $language == 0}

<p>
Stig Fyring, marinmålare och krögare, 1934-2015, har målat etiketten med Grönskärs fyr.
Stig hade en stark känsla för skärgården, nordisk matkultur och gamla dryckestraditioner
vilka alla förenas i detta brännvin.
</p>
<!-- <p>
Fyring är benämningen på en del av verksamheten vid en fyr.
Efter en rejäl arbetsdag på fyren behövde säkert fyrvaktaren och
hans arbetslag stärka sig med en sup.
</p>
-->
<br>
<hr style="width:75%;text-align:center;opacity:50%">
<br>

<em>

<p>
Stig Fyring (1934–2015), restaurateur, marine artist, and life-long Stockholmer,
has painted the lighthouse on Grönskär island. Stig was passionate about the Stockholm archipelago,
Nordic gastronomic culture, and the age-old tradition of making and
enjoying aquavit. The Fyring snaps embodies his passions.
</p>

</em>

{:else if $language == 1}

<p>
Stig Fyring, marinmålare och krögare, 1934-2015, har målat etiketten med Grönskärs fyr.
Stig hade en stark känsla för skärgården, nordisk matkultur och gamla dryckestraditioner
vilka alla förenas i detta brännvin.
</p>

{:else}

<p>
Stig Fyring (1934–2015), restaurateur, marine artist, and life-long Stockholmer,
has painted the lighthouse on Grönskär island. Stig was passionate about the Stockholm archipelago,
Nordic gastronomic culture, and the age-old tradition of making and
enjoying aquavit. The Fyring snaps embodies his passions.
</p>



{/if}

</div>
</div>
<style>
	img{
		display: inline-block;
		max-height: 500px;
		border-top:0;
		max-width: 50%;
	}
	#home-body{
		width:100%;
		text-align: center;
	}
	#text{
		display: inline-block;
		margin-left:15px;
		vertical-align:top;
		min-width: 25%;
	}
	.mobitext{
		width: 70%;
		margin-top:21px;
	}
	.nonmobitext{
		width: 25%;
		margin-top:0px;
	}
	.mobiimg{
		width: 70%;
		height:20%;
		margin-top:21px;
	}
	p{
		text-align: left;
		font-size: 13px;
	}
	a{
		text-align: left;
		font-size: 13px;
	}
</style>
